const DEFAULT_SUBDOMAIN = 'sme-customers1-nz-uat.eclipx.xyz';

export function getSubdomain() {
  const host = window.location.hostname || window.location.host;

  return host || DEFAULT_SUBDOMAIN;
}

export default getSubdomain;
